"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Simcard1G = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Simcard1G = function Simcard1G(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 160 130",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M59.0001 100.222H100C101.657 100.222 103 98.8789 103 97.222V48.5191C103 47.7175 102.679 46.9493 102.109 46.3857L91.2111 35.6108C90.6495 35.0555 89.8916 34.7441 89.1018 34.7441H59.0001C57.3432 34.7441 56.0001 36.0873 56.0001 37.7441V97.222C56.0001 98.8789 57.3432 100.222 59.0001 100.222Z",
    fill: "#D0EBF9",
    stroke: "#0095E0",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "64.1869",
    y: "72",
    width: "29.6717",
    height: "21.6571",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M82.7054 80.9629C82.7054 79.306 84.0486 77.9629 85.7054 77.9629H93.8165V88.1003H85.7054C84.0486 88.1003 82.7054 86.7571 82.7054 85.1003V80.9629Z",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M87.3351 88.6973V91.3807H71.5943V94.0641",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M75.298 85.1016C75.298 86.7584 73.9548 88.1016 72.298 88.1016L64.1868 88.1016L64.1868 77.9642L72.298 77.9642C73.9548 77.9642 75.298 79.3073 75.298 80.9642L75.298 85.1016Z",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M71.5943 77.3672L71.5943 74.6838L87.3351 74.6838L87.3351 72.0003",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "65.1869",
    y1: "82.9258",
    x2: "92.8165",
    y2: "82.9258",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "55.9445",
    cy: "58.2209",
    rx: "18.2778",
    ry: "17.8889",
    fill: "white",
    stroke: "#0095E0",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M52.4579 64.75H49.6356V53.8711L46.2665 54.916V52.6211L52.1551 50.5117H52.4579V64.75ZM65.5356 63.3125C65.1137 63.8177 64.5174 64.2109 63.7465 64.4922C62.9757 64.7682 62.1215 64.9062 61.184 64.9062C60.1997 64.9062 59.3351 64.6927 58.5903 64.2656C57.8507 63.8333 57.2778 63.2083 56.8715 62.3906C56.4705 61.5729 56.2648 60.612 56.2543 59.5078V58.7344C56.2543 57.599 56.4445 56.6172 56.8247 55.7891C57.2101 54.9557 57.7622 54.3203 58.4809 53.8828C59.2049 53.4401 60.0512 53.2188 61.02 53.2188C62.3689 53.2188 63.4236 53.5417 64.184 54.1875C64.9445 54.8281 65.395 55.763 65.5356 56.9922H63.2543C63.1502 56.3411 62.9184 55.8646 62.559 55.5625C62.2049 55.2604 61.7153 55.1094 61.0903 55.1094C60.2934 55.1094 59.6866 55.4089 59.27 56.0078C58.8533 56.6068 58.6424 57.4974 58.6372 58.6797V59.4062C58.6372 60.599 58.8637 61.5 59.3168 62.1094C59.77 62.7188 60.434 63.0234 61.309 63.0234C62.1892 63.0234 62.8168 62.8359 63.1918 62.4609V60.5H61.059V58.7734H65.5356V63.3125Z",
    fill: "#0095E0"
  }));
};
exports.Simcard1G = Simcard1G;